import {ProductContext} from '../utils'

export const resolveSKU = (context: ProductContext): string | null =>
  context.productVariant?.sku ?? null
